var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgX = function SvgX(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4049_3444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12ZM11.193 14.177L15.063 19.232L20 19.231L13.693 10.894L19.054 4.768H16.599L12.556 9.389L9.062 4.768H4L10.046 12.678L4.313 19.232H6.771L11.193 14.177ZM15.737 17.764L6.861 6.159H8.322L17.097 17.764H15.737Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4049_3444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgX);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQwNDlfMzQ0NCkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMTJDMCA1LjM3MyA1LjM3MyAwIDEyIDBDMTguNjI3IDAgMjQgNS4zNzMgMjQgMTJDMjQgMTguNjI3IDE4LjYyNyAyNCAxMiAyNEM1LjM3MyAyNCAwIDE4LjYyNyAwIDEyWk0xMS4xOTMgMTQuMTc3TDE1LjA2MyAxOS4yMzJMMjAgMTkuMjMxTDEzLjY5MyAxMC44OTRMMTkuMDU0IDQuNzY4SDE2LjU5OUwxMi41NTYgOS4zODlMOS4wNjIgNC43NjhINEwxMC4wNDYgMTIuNjc4TDQuMzEzIDE5LjIzMkg2Ljc3MUwxMS4xOTMgMTQuMTc3Wk0xNS43MzcgMTcuNzY0TDYuODYxIDYuMTU5SDguMzIyTDE3LjA5NyAxNy43NjRIMTUuNzM3WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80MDQ5XzM0NDQiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";